import { useState } from "react";
import { Formulario } from "../../shared";
import { downloadFile } from "../../shared";
import { Card } from "primereact/card";

export default function JuguetesOperaciones(props) {
  const [loader, setLoader] = useState();

  const { mostrarMensaje } = props;

  const configComunicarReevaluacion = {
    secciones: [
      {
        nombre: "Obtener test report",
        campos: [
          {
            nombre: "nroItemDni",
            tipoitemformularioid: 1,
            etiqueta: "Número de ítem DNI",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Obtener test report",
        callback: obtTestReport,
        validar: true
      }
    ]
  };

  function obtTestReport(camposFormulario) {
    setLoader(true);
    downloadFile(
      `dni/juguetes/obtTestReport/${camposFormulario.nroItemDni}`,
      `Reporte de ensayo - ${camposFormulario.nroItemDni}`,
      (respuesta) => {
        setLoader(false);
      },
      (respuesta) => {
        mostrarMensaje({
          mensaje: respuesta[0].msg,
          temporal: true,
          error: true
        });
        setLoader(false);
      }
    );
  }

  return (
    <Card>
      <Formulario
        loader={loader}
        config={configComunicarReevaluacion}
        formularioEnCuerpo
      />
    </Card>
  );
}
